import { useEffect } from "react"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"

class TabActiveState {
  isTabActive: boolean

  constructor() {
    this.isTabActive = true

    makeAutoObservable(this)
  }

  setIsTabActive(isTabActive: boolean) {
    this.isTabActive = isTabActive
  }
}

export const useIsTabActive = () => {
  const state = useMemo(() => new TabActiveState(), [])

  const handleVisibilityChange = () => {
    state.setIsTabActive(document.visibilityState === "visible")
  }

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  return state.isTabActive
}
